import PopupActions from '../../actions/PopupActions';

import PopupStore from '../../stores/PopupStore';

import Journal from './journal/Journal.react';
import Delivery from './delivery/Delivery.react';
import RemotePay from './delivery/RemotePay';
import BypassStateSystem from './delivery/BypassStateSystem.react';
import ViewProfile from '../profile/ViewProfile.react';
import Bulk from '../pos/bulk/Bulk.react';
import Loyalty from '../pos/loyalty/Loyalty.react';
import CartDetails from '../pos/sidebar/CartDetails.react';
import PosDiscount from '../pos/discount/PosDiscount.react';
import SpringBigRedeem from '../pos/springbig-redeem/SpringBigRedeem.react';
import AdjustLoyaltyPoints from '../profile/view/AdjustLoyaltyPoints.react';
import ChangeRoom from './ChangeRoom.react';
import ChangeStatus from './ChangeStatus.react';
import ClearCart from './ClearCart.react';
import CancelTransaction from './CancelTransaction.react';
import TransactionNotes from './TransactionNotes.react';
import BackDate from './BackDate.react';
import ProductInformation from './ProductInformation.react';
import EditImage from './EditImage.react';
import VGError from './VGError.react';
import DisablePos from './DisablePos.react';
import SelectCollector from './SelectCollector.react';
import PriceCheck from './price-check/PriceCheck.react';
import PosFeeDonation from '../pos/sidebar/feesDonations/PosFeeDonation.react';
import LoyaltyRegistration from './loyaltyRegistration/LoyaltyRegistration.react';
import SuperuserApprovalAudit from './compliance/SuperuserApprovalAudit.react';

class Popup extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            page : false,
            data : false,
            guest : false
        };

        this.onPopupStoreChange = this.onPopupStoreChange.bind(this);
    }

    componentDidMount() {
        PopupStore.addChangeListener(this.onPopupStoreChange);
    }

    componentWillUnmount() {
        PopupStore.removeChangeListener(this.onPopupStoreChange);
    }

    onPopupStoreChange(data) { // {page, data, guest}
        if (data.page === 'delivery')
            return;

        this.setState({
            page : data.page,
            data : data.data,
            guest : data.guest
        }, () => {
            if (data.page === 'profile') {
                $('.popup').css({
                    'top': 40,
                    'z-index': 4
                })
            } else {
                $('.popup').css({
                    'top': 0,
                    'z-index': 6
                })
            }
        });
    }

    render() {
        if (!this.state.page)
            return null;

        var data            = this.state.data;
        var guest           = this.state.guest;
        var showCloseButton = true;
        var theme           = '';

        var content = '';
        switch (this.state.page)
        {
        case 'journal':
            content = <Journal
                            data={data}
                            guest={guest} />;
            showCloseButton = false;
            theme           = 'popup__white';
            break;

        case 'profile':
            content = <ViewProfile
                            guest={guest} />;
            showCloseButton = false;
            break;

        case 'bulk':
            content = <Bulk
                            data={data}
                            guest={guest} />;
            showCloseButton = false;
            theme           = 'popup__transparent';
            break;

        case 'apply-loyalty':
            content = <Loyalty
                            guest={guest} />;
            showCloseButton = false;
            theme           = 'popup__transparent';
            break;

        case 'cart-details':
            content = <CartDetails
                            guest={guest} />;
            showCloseButton = false;
            break;

        case 'discount':
            content = <PosDiscount
                            guest={guest}
                            data={data} />;
            showCloseButton = false;
            theme           = 'popup__transparent';
            break;

        case 'fee-donation':
            content = <PosFeeDonation
                            guest={guest}
                            data={data} />;
            showCloseButton = false;
            theme           = 'popup__transparent';
            break;

        case 'redeem':
            content = <SpringBigRedeem
                        guest={guest}
                        cart={data}
                                />;
            break;

        case 'delivery':
            content = <Delivery
                            guest={guest} />;
            showCloseButton = true;
            theme           = 'popup__transparent';
            break;

        case 'adjust-loyalty':
            content = <AdjustLoyaltyPoints
                            guest={guest} />;
            showCloseButton = false;
            theme           = 'popup__transparent';
            break;

        case 'change-room':
            content = <ChangeRoom
                            guest={guest} />;
            showCloseButton = false;
            theme           = 'popup__transparent';
            break;

        case 'change-status':
            content = <ChangeStatus
                            guest={guest} />;
            showCloseButton = false;
            theme           = 'popup__transparent';
            break;

        case 'clear-cart':
            content = <ClearCart
                            guest={guest} />;
            showCloseButton = false;
            theme           = 'popup__transparent';
            break;

        case 'cancel-transaction':
            content = <CancelTransaction
                            guest={guest} />;
            showCloseButton = false;
            theme           = 'popup__transparent';
            break;

        case 'transaction-notes':
            content = <TransactionNotes
                            guest={guest} />;
            showCloseButton = false;
            theme           = 'popup__transparent';
            break;

        case 'back-date':
            content = <BackDate
                            guest={guest} />;
            showCloseButton = false;
            theme           = 'popup__transparent';
            break;

        case 'product-information':
            content = <ProductInformation
                            guest={guest}
                            data={data} />;
            showCloseButton = false;
            theme           = 'popup__transparent';
            break;

        case 'edit-image':
            content = <EditImage
                            guest={guest}
                            data={data} />;
            showCloseButton = true;
            theme           = 'popup__transparent';
            break;

        case 'vg-error':
            content = <VGError
                            guest={guest}
                            data={data} />;
            showCloseButton = false;
            theme           = 'popup__transparent';
            break;

        case 'disable-pos':
            content = <DisablePos
                            guest={guest}
                            data={data} />;
            showCloseButton = false;
            theme           = 'popup__transparent';
            break;
        case 'select-collector':
            content = <SelectCollector
                            guest={guest}
                            data={data} />;
            showCloseButton = false;
            theme           = 'popup__transparent';
            break;
        case 'price-check':
            content = <PriceCheck/>;
            showCloseButton = false;
            theme           = 'popup__transparent';
            break;
        case 'superuser-approval-audit':
            content = <SuperuserApprovalAudit guest={guest} />;
            showCloseButton = true;
            theme ='popup__transparent';
            break;
        case 'bypassStateSystem':
            content = (
                <BypassStateSystem
                    shipmentId={data.shipmentId}
                    guest={guest}
                />
            )
            showCloseButton = false;
            theme           = 'popup__transparent';
            break;
        case 'loyalty-registration':
            content = (
                <LoyaltyRegistration
                    data={data}
                    guest={guest}
                />
            );
            showCloseButton = true;
            theme           = 'popup__white';
            break;
        case 'remotepay':
            content = (
                <RemotePay
                    shipmentId={data.shipmentId}
                    guest={guest}
                />
            );
            showCloseButton = true;
            theme           = 'popup__transparent';
            break;            
        }
        
        return (
            <div
                className={'popup '+theme}>

                {content}

                { showCloseButton &&
                    <div
                        className='popup__close'
                        onClick={() => { PopupActions.close(); }}>

                        <i className='fa fa-times' aria-hidden='true' />
                    </div>
                }
            </div>
        );
    }
}

export default Popup;


// WEBPACK FOOTER //
// ./ui_src/app/components/popup/Popup.react.jsx